<div class="login-page">
  <div class="login-card">
    <div class="login-container">
      <!-- Left Panel -->
      <div class="w-50 d-lg-block d-none">
        <app-left-ui-template></app-left-ui-template>
      </div>
      <div class="center-divider"></div>
      <div class="login-form">
        <a [routerLink]="['/']" class="btn home-btn">
          <i class="fa-solid fa-arrow-left"></i> Home
        </a>
        <div class="form-container">
          <div class="form-header">
            <img src="assets/images/Vector.png" class="mb-2" />

            <h2 class="form-title">Sign In</h2>
            <p class="form-subtitle">Please sign in to your account</p>
          </div>

          <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
            <p>
              <i class="bi bi-exclamation-triangle me-2"></i>
              {{ errorMessage }}
            </p>
            <button
              type="button"
              class="btn-close"
              (click)="clearError()"></button>
          </div>

          <!-- Form starts -->
          <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
            <div class="form-group">
              <label for="email">Email</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="Enter your email"
                class="form-control"
                [(ngModel)]="loginModel.email"
                required
                [disabled]="isLoading()"
                #email="ngModel" />
              <div
                *ngIf="email.invalid && (email.dirty || email.touched)"
                class="error-message text-danger">
                <small *ngIf="email.errors?.['required']"
                  >Email or username is required.</small
                >
              </div>
            </div>

            <div class="form-group has-toggle mb-2">
              <label for="password">Password</label>
              <div class="password-wrap">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  class="form-control"
                  [(ngModel)]="loginModel.password"
                  required
                  [disabled]="isLoading()"
                  #password="ngModel" />
                <button
                  type="button"
                  class="toggle-password"
                  (click)="togglePasswordVisibility()"
                  [attr.aria-label]="
                    showPassword ? 'Hide password' : 'Show password'
                  ">
                  <i
                    [ngClass]="
                      showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                    "></i>
                </button>
              </div>
              <div
                *ngIf="password.invalid && (password.dirty || password.touched)"
                class="error-message text-danger">
                <small *ngIf="password.errors?.['required']"
                  >Password is required.</small
                >
              </div>
            </div>
            <div class="form-options">
              <div class="remember-me">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  [(ngModel)]="rememberMe"
                  [disabled]="isLoading()" />
                <label for="rememberMe">Remember me</label>
              </div>
              <a routerLink="/auth/forgot-password" style="text-decoration: underline;">Forgot Password</a>
            </div>
            <button
              type="submit"
              class="login-btn"
              [disabled]="loginForm.invalid || isLoading()">
              <span *ngIf="!isLoading()">Sign In</span>
              <span *ngIf="isLoading()">
                <i class="bi bi-arrow-repeat spin me-2"></i>Signing In...
              </span>
            </button>
          </form>
          <p style="color: gray" class="text-center text-sm font-medium mt-5">
            New to Clocc That Tea?
            <span
            style="color: #D32A8D"
            class="font-semibold text-decoration-underline custom-text"
            (click)="onSignUpClick()"
            >Sign Up</span>
            <!-- <a [href]="this.pwaUrl" style="color: #D32A8D" class="font-semibold text-decoration-underline custom-text">
                Sign Up
            </a> -->
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
